import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import "./index.css";

// redux store imports

import { beneLookUp } from "../../../redux/features/verifyPAN/verifyPAN";
import { scheduleInternalTxnView } from "../../../redux/features/scheduleInternalTxn";
import { beneBankLookUp } from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { getRefreshTokenNew } from "../../../redux/features/refreshToken/refreshToken";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { beneCategories } from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { beneInternalViewAllAcc } from "../../../redux/features/internalApi/internalApi.js";
import { ownerListViewAllAcc } from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification.js";

// component imports
import PaginationComponent from "../../../components/_utils/PaginationComponent";
import Loader from "../../../components/Loader/Index";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent";
import FormatAmount from "../../../components/_utils/FormatAmount/FormatAmount.js";
import ScheduleIntTxnViewAllCard from "../../../../src/components/ScheduleInternalTxn/ScheduleInternalTxnViewAllCard";
import useCustomSearchParams from "../../../utils/useCustomSearchParams.js";
import { standardAccountNumberFormat } from "../../../utils/standardAccountNumberFormat.js";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider.js";

const ScheduleInternalTransactionViewSchedule = (props) => {
  const dispatch = useDispatch();
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const duplicateFilters = props?.duplicateFilters;

  const { searchParam, handleClearSearchParam, handleSearchParams } =
    useCustomSearchParams({
      pageno: GlobalConfiguration.lengthCheckOne,
      pagesize: dropdownOptions[0],
    });
  const ctaRef = useRef(null);
  const searchBarContainer = useRef(null);
  const searchBarRef = useRef(null);
  const scrollRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName: "",
    beneAccountId: props?.internal_account_id ? props?.internal_account_id : "",
    bankAccountNo: props?.destination_account_number
      ? props?.destination_account_number
      : "",
    bankAccountIFSC: "",

    ownerAccountId: props?.owner_account_id ? props?.owner_account_id : "",
    amount: "",
    ownerbankAccountNo: props?.source_account_number
      ? props?.source_account_number
      : "",
  });

  const [IFSC, setIFSC] = useState("");
  const [bankLogo, setBankLogo] = useState("");
  const [hideCarousal, setHideCaroursal] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(false);

  const [FrequencyMethodfilter, setFrequencyMethodfilter] = useState(
    searchParam.get("frequency") || "",
    "",
  );
  const [isPaymentMethod, setIsPaymentMethod] = useState(
    props?.txnHistorytype === "internalScheduleCreateTxn" &&
      duplicateFilters?.payment_method
      ? duplicateFilters?.payment_method
      : searchParam.get("paymentmethod") || "",
    "",
  );
  const [currentStatus, setCurrentStatus] = useState(
    props?.type === "scheduleInternalAcc"
      ? "pending"
      : searchParam.get("lifecycle") || "",
    "",
  );
  const [confidentialMethodFilter, setConfidentialMethodFilter] = useState(
    (props?.txnHistorytype === "internalScheduleCreateTxn" &&
      duplicateFilters?.confidential_transaction ===
        "Show only confidential") ||
      (props?.isConf ?? false)
      ? "Show only confidential"
      : searchParam.get("confidential") || "",
    "",
  );

  const [txnAmountFilter, setTxnAmountFilter] = useState(
    props?.txnHistorytype === "internalScheduleCreateTxn" &&
      props?.txnPayLoad?.amount
      ? props?.txnPayLoad?.amount
      : searchParam.get("amount") || "",
    "",
  );

  const [DestinationAccountName, setDestinationAccountName] = useState(
    props?.txnHistorytype === "internalScheduleCreateTxn" &&
      props?.txnPayLoad?.beneAccountId
      ? props?.txnPayLoad?.beneAccountId
      : props?.txnHistorytype === "Schedule_Internal_Txn" ||
          props?.type === "scheduleInternalAcc"
        ? props?.internal_account_id
        : searchParam.get("internalAcc") || "",
    "",
  );
  const [startDate, setStartDate] = useState(
    searchParam.get("startDate")
      ? new Date(searchParam.get("startDate")) || ""
      : "",
  );
  const [endDate, setEndDate] = useState(
    searchParam.get("endDate")
      ? new Date(searchParam.get("endDate")) || ""
      : "",
  );
  const [startDateFilter, setStartDateFilter] = useState(
    searchParam.get("startDate")
      ? new Date(searchParam.get("startDate")) || ""
      : "",
  );
  const [endDateFilter, setEndDateFilter] = useState(
    searchParam.get("endDate")
      ? new Date(searchParam.get("endDate")) || ""
      : "",
  );
  const [txnPayLoadFilter, setTxnPayLoadFilter] = useState(
    props?.source_account_number ?? "",
  );

  const [txnPayLoadAccountNameFilter, setTxnPayLoadAccountNameFilter] =
    useState(
      props?.txnHistorytype === "internalScheduleCreateTxn" &&
        props?.txnPayLoad?.ownerId
        ? props?.txnPayLoad?.ownerId
        : props?.txnHistorytype === "Schedule_Internal_Txn" &&
            props?.owner_account_id
          ? props?.owner_account_id
          : searchParam.get("sourceAcc") || "",
      "",
    );
  const [txnPayLoadDesitinationNameFilter, setTxnPayLoadDestinationNameFilter] =
    useState(props?.destination_account_number ?? "");

  const [filterPayload, setFilterPayload] = useState({
    pagination: 0,
    accNoInput: "",
    currentPage: 1,
    sortBank: "",
    sortAccountNo: "",
    bankNameInput: "",
    currentPageText: "01",
    beneAccountSearch: "",
    searchTerm: "",
  });

  const [accountModalSearch, setAccountModalSearch] = useState(false);
  const [category, setCategory] = useState(
    txnPayLoad?.categories ? txnPayLoad?.categories?.split(",") : [],
  );
  const [accountName, setAccountName] = useState(
    txnPayLoad?.bankAccountName ? txnPayLoad?.bankAccountName : "",
  );
  const [accountNumber, setAccountNumber] = useState(
    props?.txnHistorytype === "internalScheduleCreateTxn" &&
      props?.txnPayLoad?.ownerBankAccountNo
      ? props?.txnPayLoad?.ownerBankAccountNo
      : txnPayLoad?.bankAccountNo
        ? txnPayLoad?.bankAccountNo
        : "",
  );
  const [panNumber, setPanNumber] = useState(
    txnPayLoad?.pan ? txnPayLoad?.pan : null,
  );
  const [IFSC1, setIFSC1] = useState(
    txnPayLoad?.bankAccountIFSC ? txnPayLoad?.bankAccountIFSC : "",
  );
  const [bankLogo1, setBankLogo1] = useState(
    txnPayLoad?.bankLogo ? txnPayLoad?.bankLogo : "",
  );
  const [beneAccountId, setBeneAccountId] = useState(
    txnPayLoad?.beneAccountId ? txnPayLoad?.beneAccountId : null,
  );

  const [accumulatedData, setAccumulatedData] = useState([]);
  const [mainData, setMainData] = useState([]);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [searchdata, SetsearchData] = useState(
    searchParam.get("search") || "",
    "",
  );
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [initCategoryFilter, setInitCategoryFilter] = useState(
    searchParam.get("category") || "",
    "",
  );
  const [accountNameValue, setAccountNameValue] = useState("");

  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );

  const services = useSelector((state) => state.refreshToken.services);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const FREQUENCY_MAP = {
    "Once": "once",
    "Daily": "daily",
    "Weekly": "weekly",
    "Fortnightly": "fortnightly",
    "Monthly": "monthly",
    "Quarterly": "quarterly",
    "Half yearly": "half_yearly",
    "Yearly": "yearly",
  };

  const handleFrequencyMethod = (uiValue) => {
    const apiValue = FREQUENCY_MAP[uiValue] || uiValue.toLowerCase();
    handleSubmit("frequency", apiValue);
    setFrequencyMethodfilter(apiValue);
  };

  const handlePaymentMethod = (selectedSettlement) => {
    setIsPaymentMethod(selectedSettlement);
  };

  const handleConfidentialMethod = (selectedSettlement) => {
    setConfidentialMethodFilter(selectedSettlement);
  };

  const formatDate = (date) => {
    return format(new Date(date), "dd MMM, yyyy");
  };

  const handlePagination = (page) => {
    handleSubmit("pageno", page);
    setCurrentPage(page);
  };

  const handleSelect = (value) => {
    handleSubmit("pagesize", value);
    setSelectedValue(value);
    setPageSize(value);
    setAccumulatedData([]);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    toggleDropdown();
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const handleAction = async () => {
    try {
      setLoading(true);

      let queryParams1 = {
        page_no: currentPage,
        page_item_count: pageSize,
      };

      const addParamsBasedOnSelection = () => {
        if (FrequencyMethodfilter !== "") {
          queryParams1.frequency = FrequencyMethodfilter;
        }
        if (initCategoryFilter !== null) {
          queryParams1.category = initCategoryFilter;
        }
        if (currentStatus && currentStatus !== "all") {
          if (currentStatus === "Require approval") {
            queryParams1.lifecycle_status = "pending";
          } else if (currentStatus === "Discarded") {
            queryParams1.lifecycle_status = "deleted";
          } else {
            queryParams1.lifecycle_status = currentStatus;
          }
        }
        if (isPaymentMethod && isPaymentMethod !== "All") {
          queryParams1.payment_method = isPaymentMethod;
        }
        if (confidentialMethodFilter !== "") {
          queryParams1.confidential_transaction = confidentialMethodFilter;
        }
        if (startDateFilter) {
          queryParams1.transaction_start_date = formatDate(startDateFilter);
        }

        if (endDateFilter) {
          queryParams1.transaction_end_date = formatDate(endDateFilter);
        }
        if (txnAmountFilter !== "") {
          queryParams1.amount = txnAmountFilter;
        }
        if (DestinationAccountName !== "") {
          queryParams1.internal_account_id = DestinationAccountName;
        }

        if (txnPayLoadAccountNameFilter !== "") {
          queryParams1.owner_account_id = txnPayLoadAccountNameFilter;
        }
        if (searchdata !== "") {
          queryParams1.scheduled_name = searchdata;
        }
      };
      addParamsBasedOnSelection();

      const response = await dispatch(scheduleInternalTxnView(queryParams1));
      setMainData(response?.payload);
      setLoading(true);
      const newData = response?.payload?.transactions || [];
      setAccumulatedData(newData);
    } catch (error) {
      setAccumulatedData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    setLoadingData(true);

    let response;
    let data = [];

    try {
      switch (active) {
        case "Category":
          response = await dispatch(
            beneCategories({ search_string: searchUserTextDebounce }),
          );
          data =
            response?.payload?.categories?.map((itm) => ({
              id: itm.name,
              Category: itm.name,
              Description: itm?.description || "Not given",
            })) || [];
          break;

        case "Internal account":
          response = await dispatch(
            beneInternalViewAllAcc({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.internal_accounts?.map((itm) => ({
                id: itm.id,
                Name: itm.name,
                Account_number: itm.bank_acc_no,
                display: itm.name,
                IFSC_code: itm.ifsc_code,
                Contact_number: itm.contact_no,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;
        case "search":
          if (searchUserTextDebounce === "") {
            SetsearchData("");
          } else {
            SetsearchData(searchUserTextDebounce);
          }
          setLoading(false);
          break;

        case "Owner account":
          response = await dispatch(
            ownerListViewAllAcc({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.owner_accounts?.map((itm) => ({
                id: itm.id,
                Account_number: itm.bank_acc_no,
                display: itm.bank_acc_no,
                Name: itm.name,
                IFSC_code: itm.ifsc_code,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;
        case "Search":
          SetsearchData(searchUserTextDebounce);
          setLoadingData(false);

          break;

        default:
          data = [];
          break;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      data = [];
    } finally {
      setInputData([...data]);
      setLoadingData(false);
    }
  };

  const popupType = () => {
    if (props?.txnHistorytype === "Schedule_Internal_Txn" && !props?.isConf) {
      return "history";
    }
    if (props?.typepop === "scheduleInternalAcc" && !props?.isConf) {
      return "associate";
    }
    if (props?.txnHistorytype === "Schedule_Internal_Txn" && props?.isConf) {
      return "confidential";
    }
  };

  const statuses = [
    "approved",
    "Require approval",
    "pending",
    "rejected",
    "Discarded",
  ];

  const filteredStatuses = statuses.filter((status) => {
    const hasAdmin = services?.includes("Admin");
    const hasAInternal = services?.includes("IAScheduledTxn");
    const hasCInternal = services?.includes("ICScheduledTxn");
    const internalTxn =
      hasCInternal &&
      !hasAInternal &&
      !hasAdmin &&
      status === "Require approval";

    const ScheduleInternalTxn =
      hasAInternal && !hasCInternal && !hasAdmin && status === "pending";

    if (internalTxn) {
      return false;
    }

    if (ScheduleInternalTxn) {
      return false;
    }

    if (hasAdmin && hasAInternal && hasCInternal) {
      return true;
    }

    return true;
  });

  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      isPaymentMethod !== "" ||
        FrequencyMethodfilter !== "" ||
        confidentialMethodFilter !== "" ||
        txnPayLoadFilter !== "" ||
        txnPayLoadDesitinationNameFilter !== "" ||
        searchdata !== "" ||
        initCategoryFilter !== "" ||
        startDateFilter ||
        endDateFilter ||
        txnAmountFilter !== "" ||
        DestinationAccountName !== "" ||
        txnPayLoadAccountNameFilter !== "",
    );
  };

  const handleSubmit = (key, value) => {
    if (
      props?.type !== "scheduleInternalAcc" &&
      props?.txnHistorytype !== "scheduleInternalAccApproval" &&
      props?.txnHistorytype !== "Schedule_Internal_Txn" &&
      props?.type !== "scheduleInternalAcc" &&
      popupType() !== "confidential" &&
      popupType() !== "history" &&
      popupType() !== "associate"
    ) {
      handleSearchParams(key, value);
    }
  };
  const hasData =
    accumulatedData?.length > GlobalConfiguration?.lengthCheckZero;

  const showClearButton =
    isPaymentMethod?.length ||
    FrequencyMethodfilter?.length ||
    confidentialMethodFilter?.length ||
    txnPayLoadFilter?.length ||
    startDateFilter?.length ||
    endDateFilter?.length ||
    txnAmountFilter?.length ||
    txnPayLoadDesitinationNameFilter?.length ||
    currentStatus?.length ||
    searchdata?.length ||
    DestinationAccountName?.length ||
    startDate ||
    endDate;

  const isAmountFieldDisabled =
    loading ||
    (props?.txnHistorytype === "internalScheduleCreateTxn" &&
      props?.txnPayLoad?.amount);

  const handleClearAll = () => {
    handleClearSearchParam();
    SetsearchData("");

    props?.txnHistorytype !== "internalScheduleCreateTxn" &&
      setIsPaymentMethod("");

    setFrequencyMethodfilter("");

    if (
      props?.txnHistorytype !== "Schedule_Internal_Txn" &&
      props?.txnHistorytype !== "internalScheduleCreateTxn" &&
      props?.type !== "scheduleInternalAcc" &&
      !props?.isConf
    ) {
      setTxnPayLoadFilter("");
      setTxnPayLoad((prev) => ({ ...prev, ownerbankAccountNo: "" }));
      setTxnPayLoadAccountNameFilter("");
      setTxnPayLoadDestinationNameFilter("");
      setTxnPayLoad((prev) => ({ ...prev, bankAccountNo: "" }));
      setDestinationAccountName("");
    }

    setStartDate(null);
    setStartDateFilter("");
    setEndDate(null);
    setEndDateFilter("");

    props?.txnHistorytype !== "internalScheduleCreateTxn" &&
      setTxnAmountFilter("");

    setTxnPayLoad((prev) => ({ ...prev, amount: "" }));

    !props?.isConf && setConfidentialMethodFilter("");

    if (props.type !== "scheduleInternalAcc") {
      setCurrentStatus("");
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      const isInsideSearch =
        searchBarContainer.current &&
        searchBarContainer.current.contains(e.target);
      const isInsideToggle =
        searchBarRef.current && searchBarRef.current.contains(e.target);
      const isInsideClear = ctaRef.current && ctaRef.current.contains(e.target);

      if (
        showSearchBar &&
        !isInsideSearch &&
        !isInsideToggle &&
        !isInsideClear
      ) {
        setShowSearchBar(false);
        setShowInnerSearchBar(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [showSearchBar]);

  useEffect(() => {
    if (scrollRef) {
      if (scrollRef?.current?.scrollWidth > scrollRef?.current?.clientWidth) {
        setHideCaroursal(true);
      } else {
        setHideCaroursal(false);
      }
    }
  }, [
    txnPayLoadDesitinationNameFilter,
    txnPayLoadAccountNameFilter,
    startDateFilter,
    DestinationAccountName,
    FrequencyMethodfilter,
    endDateFilter,
    confidentialMethodFilter,
    txnAmountFilter,
    searchdata,
    initCategoryFilter,
  ]);

  useEffect(() => {
    if (active?.length) {
      fetchData();
    }
  }, [active]);

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    handleAction();
  }, [
    markerData,
    currentPage,
    pageSize,
    isPaymentMethod,
    txnPayLoadDesitinationNameFilter,
    txnPayLoadAccountNameFilter,
    currentStatus,
    startDateFilter,
    DestinationAccountName,
    FrequencyMethodfilter,
    endDateFilter,
    confidentialMethodFilter,
    txnAmountFilter,
    searchdata,
    initCategoryFilter,
  ]);

  useEffect(() => {
    updateIsFilterApplied();
  }, [
    FrequencyMethodfilter,
    isPaymentMethod,
    confidentialMethodFilter,
    txnPayLoadFilter,
    txnPayLoadDesitinationNameFilter,
    initCategoryFilter,
    startDateFilter,
    endDateFilter,
    txnAmountFilter,
    searchdata,
    DestinationAccountName,
    txnPayLoadAccountNameFilter,
  ]);

  return (
    <div
      className={`overflow-y-hidden Qsmd:overflow-auto flex flex-col bg-primary-bg ${props?.type === "scheduleInternalAcc" || props?.txnHistorytype === "Schedule_Internal_Txn" || props?.txnHistorytype === "internalScheduleCreateTxn" ? "h-full" : "h-full-height"}`}
    >
      <div
        className={` bg-primary-nav relative z-z-index-overlay ${
          (props?.type === "scheduleInternalAcc" &&
            props?.txnHistorytype === "scheduleInternalAccApproval") ||
          props?.txnHistorytype === "Schedule_Internal_Txn" ||
          props?.txnHistorytype === "internalScheduleCreateTxn" ||
          props?.txnHistorytype === ""
            ? "hidden"
            : "Qsmd:h-navbar-breadcrumb-height "
        }`}
      ></div>
      <div className="z-z-index-overlay">
        <TopNavComponent
          filteredSearchProps={{
            setShowInnerSearchBar: setShowInnerSearchBar,
            showSearchBar: showSearchBar,
            isSearchDisabled: loading,
            onSearchInput: (val) => {
              setSearchUserTextDebounce(val);
            },

            searchText: searchUserTextDebounce,
            searchPlaceholder: "Search schedule internal transaction",
            filterPlaceholder: "Schedule name",
            filterItems: [
              {
                name: "Search",
                isMulti: false,
                value: searchdata,
                setValue: (val) => {
                  handleSubmit("search", val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  SetsearchData(val);
                },
                isDropdown: false,
                isDisabled: loading,
              },
              {
                name: "Internal account",
                short_name: "Internal. Acc",
                isMulti: false,
                value: props?.internal_account_name
                  ? props?.internal_account_name
                  : DestinationAccountName,
                displayValue:
                  props?.txnHistorytype === "internalScheduleCreateTxn"
                    ? standardAccountNumberFormat(
                        props?.txnPayLoad?.bankAccountNo,
                        true,
                      )
                    : accountNameValue?.toLowerCase() ||
                      accountNumber?.toLowerCase(),
                setValue: (val) => {
                  handleSubmit("internalAcc", val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  setDestinationAccountName(val);
                },
                setDisplayValue: (val) => {
                  setAccountName(val);
                  setAccountNameValue(val);
                },
                isDropdown: true,
                valueType: "string",
                isDisabled:
                  props.type === "scheduleInternalAcc" ||
                  props?.txnHistorytype === "internalScheduleCreateTxn"
                    ? true
                    : loading
                      ? true
                      : popupType() === "confidential" ||
                        popupType() === "history" ||
                        popupType() === "associate",
              },
              {
                name: "Owner account",
                short_name: "Src. Acc",
                isMulti: false,
                value: txnPayLoadAccountNameFilter,
                displayValue: standardAccountNumberFormat(accountNumber, true),
                setValue: (val) => {
                  handleSubmit("sourceAcc", val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  setTxnPayLoadAccountNameFilter(val);
                },
                setDisplayValue: setAccountNumber,
                valueType: "string",
                isDropdown: true,
                isDisabled:
                  loading ||
                  (props?.txnHistorytype === "internalScheduleCreateTxn" &&
                    props?.txnPayLoad?.ownerId)
                    ? true
                    : props?.txnHistorytype === "Schedule_Internal_Txn",
              },
              {
                name: "Amount",
                short_name: "Amt - INR",
                isMulti: false,
                value: txnAmountFilter,
                setValue: (val) => {
                  if (isAmountFieldDisabled) return;
                  handleSubmit("amount", val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  setTxnAmountFilter(val);
                },
                displayValue: FormatAmount({
                  price: txnAmountFilter,
                }),
                isDropdown: false,
                isDisabled: isAmountFieldDisabled,
                valueType: "number",
              },
            ],
            filters: [
              {
                name: "Approval status",
                filterType: "dropdown",
                variant: "single",
                value: currentStatus,
                options: filteredStatuses.map((status) => status),
                dropdownPlaceHolder:
                  currentStatus === "deleted"
                    ? "Discard"
                    : currentStatus === "rejected"
                      ? "Rejected"
                      : "Select status",
                isDisabled:
                  props?.type === "scheduleInternalAcc" ? true : false,
                statusPop: true,
                handleChange: (val) => {
                  handleSubmit("lifecycle", val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  setCurrentStatus(val);
                },
              },
              {
                name: "Schedule start date",
                filterType: "calender",
                variant: "single",
                size: "small",
                value: startDateFilter,
                startDate: startDate,
                handleChange: (value) => {
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  setStartDate(value);
                  handleSubmit("startDate", value);
                  setStartDateFilter(value);

                  if (endDate && new Date(value) > new Date(endDate)) {
                    setEndDate("");
                    setEndDateFilter("");
                    handleSubmit("endDate", "");
                  }
                },
                maxDate: null,
              },
              {
                name: "Schedule end date",
                filterType: "calender",
                variant: "single",
                size: "small",
                value: endDateFilter,
                startDate: endDate,
                handleChange: (value) => {
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);

                  setEndDate(value);
                  handleSubmit("endDate", value);
                  setEndDateFilter(value);

                  if (startDate && new Date(value) < new Date(startDate)) {
                    setStartDate("");
                    handleSubmit("startDate", "");
                    setStartDateFilter("");
                  }
                },
                minDate: startDateFilter || new Date(),
                maxDate: null,
              },
              {
                name: "Payment method",
                filterType: "dropdown",
                variant: "single",
                isSearch: false,
                options: ["NEFT", "RTGS"],
                searchPlaceholder: "Search",
                dropdownType: "PaymentMethod",
                dropdownPlaceHolder: "Select type",
                value: isPaymentMethod,
                isDisabled:
                  props?.txnHistorytype === "internalScheduleCreateTxn" &&
                  duplicateFilters?.payment_method,
                handleChange: (val) => {
                  handleSubmit("paymentmethod", val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  handlePaymentMethod(val);
                },
              },
              services?.includes("VConfidentialTxn") && {
                name: "Show/hide confidential transactions",
                filterType: "dropdown",
                variant: "single",
                isSearch: false,
                options: ["Show only confidential", "Hide confidential"],
                searchPlaceholder: "Search",
                isDisabled:
                  (props?.txnHistorytype === "internalScheduleCreateTxn" &&
                    duplicateFilters?.confidential_transaction ===
                      "Show only confidential") ||
                  popupType() === "confidential",
                dropdownPlaceHolder: "Default (all transactions)",
                value: confidentialMethodFilter,
                handleChange: (val) => {
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  handleSubmit("confidential", val);
                  handleConfidentialMethod(val);
                },
              },
              {
                name: "Frequency",
                filterType: "dropdown",
                variant: "single",
                isSearch: false,
                options: [
                  "Once",
                  "Daily",
                  "Weekly",
                  "Fortnightly",
                  "Monthly",
                  "Quarterly",
                  "Half yearly",
                  "Yearly",
                ],
                searchPlaceholder: "Search",
                dropdownPlaceHolder: "Select frequency",
                value:
                  Object.keys(FREQUENCY_MAP).find(
                    (key) => FREQUENCY_MAP[key] === FrequencyMethodfilter,
                  ) || FrequencyMethodfilter,
                isDisable: false,
                handleChange: (val) => {
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  handleFrequencyMethod(val);
                },
              },
            ],

            isFilterClearAllDisabled:
              props?.txnHistorytype === "internalScheduleCreateTxn" &&
              duplicateFilters?.payment_method
                ? !(
                    FrequencyMethodfilter?.length ||
                    startDateFilter ||
                    (props?.txnHistorytype === "internalScheduleCreateTxn" &&
                      duplicateFilters?.confidential_transaction !==
                        "Show only confidential" &&
                      confidentialMethodFilter) ||
                    endDateFilter ||
                    (props?.type !== "scheduleInternalAcc" &&
                      currentStatus?.length)
                  )
                : !(
                    isPaymentMethod?.length ||
                    FrequencyMethodfilter?.length ||
                    (popupType() !== "confidential" &&
                      confidentialMethodFilter?.length) ||
                    startDateFilter ||
                    endDateFilter ||
                    (props?.type !== "scheduleInternalAcc" &&
                      currentStatus?.length) ||
                    loading
                  ),

            isSearchClearAllDisabled:
              props?.txnHistorytype === "internalScheduleCreateTxn" &&
              props?.txnPayLoad?.amount
                ? !(initCategoryFilter?.length || searchdata?.length)
                : !(
                    initCategoryFilter?.length ||
                    (popupType() !== "history" &&
                      popupType() !== "confidential" &&
                      popupType() !== "associate" &&
                      props?.type !== "scheduleInternalAcc" &&
                      DestinationAccountName?.length) ||
                    (popupType() !== "history" &&
                      popupType() !== "confidential" &&
                      popupType() !== "associate" &&
                      props?.type !== "scheduleInternalAcc" &&
                      beneAccountId?.length) ||
                    searchdata?.length ||
                    txnAmountFilter?.length ||
                    txnPayLoadAccountNameFilter?.length ||
                    loading
                  ),

            inputData: inputData,
            active: active,
            setActive: setActive,
            loading: loading,
            setLoading: setLoadingData,
            isShowFilter: true,
          }}
          BottomSubText={
            "Below are the schedules’ details. Approved schedules will generate transactions according to the specified frequency."
          }
        />
      </div>

      {showInnerSearchBar && (
        <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
      )}

      <div
        ref={scrollRef}
        className={`flex flex-col relative flex-1 items-center  
          h-height-full overflow-x-hidden ${!accumulatedData?.length && "justify-center"} ${props?.type === "scheduleInternalAcc" || props?.txnHistorytype === "internalScheduleCreateTxn" ? "" : ""}   ${showInnerSearchBar ? "overflow-y-hidden" : "overflow-y-auto"}`}
        style={{
          paddingTop:
            !showSearchBar &&
            isFilterApplied &&
            !accumulatedData.length &&
            (props?.txnHistorytype === "Schedule_Internal_Txn" ||
              props?.type === "scheduleInternalAcc" ||
              props?.txnHistorytype === "internalScheduleCreateTxn") &&
            !hideCarousal
              ? "var(--padding-md)"
              : isFilterApplied &&
                  !accumulatedData.length &&
                  (props?.txnHistorytype === "Schedule_Internal_Txn" ||
                    props?.type === "scheduleInternalAcc" ||
                    props?.txnHistorytype === "internalScheduleCreateTxn")
                ? "var(--padding-md)"
                : "",
          scrollPaddingTop: "var(--padding-md)",
          scrollPaddingBottom: "var(--padding-md)",
        }}
      >
        <div className="flex flex-col items-center w-full z-z-index-base flex-1">
          {loading ? (
            <div className="loader-container m-auto flex justify-center items-center w-width-full h-height-full">
              <Loader />
            </div>
          ) : hasData ? (
            <div className="flex flex-col min-h-height-base flex-1 w-width-full h-full-height">
              <ScheduleIntTxnViewAllCard
                openTxnHistory={props.openTxnHistory}
                setLoading={setLoading}
                data={accumulatedData}
                filterRef={scrollRef}
                currentStatus={currentStatus}
                txnHistorytype={props?.txnHistorytype}
                typepop={props?.type}
                onClose={props?.onClose}
              />
            </div>
          ) : (
            <div
              className="h-height-full opacity-dark-opacity flex flex-col items-center justify-center Qmd:m-auto mx-auto my-margin-xl gap-gap-sm"
              style={{
                opacity:
                  isSidebarOpen || showInnerSearchBar
                    ? "var(--light-opacity)"
                    : "var(--base-opacity)",
              }}
            >
              <img
                src="https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                alt="No data found"
                className="w-graphic-width-md h-graphic-rectangle-height-md"
              />

              <p className="text-font-sm text-text-primary">No data found.</p>

              {showClearButton && (
                <PrimaryButton
                  enabledBgColor="var(--primary-act)"
                  btnText="Clear parameters"
                  enabledTextColor="var(--text-primary)"
                  handleFunction={handleClearAll}
                  buttonRef={ctaRef}
                  hoverOption="white"
                />
              )}
            </div>
          )}
        </div>
      </div>
      {!loading &&
        accumulatedData?.length > GlobalConfiguration?.lengthCheckZero && (
          <div
            className={`${
              props?.txnHistorytype === "Schedule_Internal_Txn" ||
              props?.type === "scheduleInternalAcc"
                ? "w-width-full rounded-none Qsmd:rounded-b-border-radius-md"
                : props?.txnHistorytype === "internalScheduleCreateTxn"
                  ? "w-width-full rounded-none Qsmd:rounded-b-border-radius-md"
                  : `w-width-full  rounded-none z-z-index-base ${isSidebarOpen && "pointer-events-none"}`
            }`}
          >
            <PaginationComponent
              handleSelect={handleSelect}
              selectedValue={selectedValue}
              data={mainData}
              pageSize={pageSize}
              dropdownOptions={dropdownOptions}
              handlePagination={handlePagination}
              currentPage={currentPage}
              payload={props?.payload}
              setIsOpen={setIsOpen}
              type={
                props?.type === "scheduleInternalAcc"
                  ? "scheduleInternalAcc"
                  : ""
              }
            />
          </div>
        )}
    </div>
  );
};

export default ScheduleInternalTransactionViewSchedule;
